import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { TimelineEvent } from '../../../models/TimelineEvent';
import TimelineEventCard from './timeline-event-card';

interface TimelineDateGroupProps {
  dateLabel: string;
  events: TimelineEvent[];
  getIsLastEvent: (eventId: string, groupIndex: number) => boolean;
  groupIndex: number;
}

export default function TimelineDateGroup({
  dateLabel,
  events,
  getIsLastEvent,
  groupIndex
}: TimelineDateGroupProps) {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen} className="mb-1">
      <div className="sticky top-0 z-20 bg-background/95 backdrop-blur-sm border-b border-border/40 py-1.5 px-2">
        <CollapsibleTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            className="w-full justify-between h-7 px-2 text-xs font-medium text-muted-foreground hover:text-foreground"
          >
            <span>{dateLabel}</span>
            {isOpen ? (
              <ChevronDown className="h-3 w-3" />
            ) : (
              <ChevronRight className="h-3 w-3" />
            )}
          </Button>
        </CollapsibleTrigger>
      </div>
      <CollapsibleContent>
        <div className="pl-2 pr-2 pb-1 space-y-1">
          {events.map((event, eventIndex) => (
            <div key={event._id}>
              <TimelineEventCard
                event={event}
                isLast={getIsLastEvent(event._id, groupIndex) && eventIndex === events.length - 1}
              />
            </div>
          ))}
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
}

